import { NewTierPlan } from './getNewTierPlans';

// Subconjunto de ExplorePlanOffer (app/hooks/useSubscriptionPlans/usePlansCatalog) necessário pra
// montar o checkout — já traz o gateway_id com a precedência de cupom (OAB) resolvida.
export type SelectableOffer = {
  key: NewTierPlan['key'];
  id: number | string;
  title: string;
  priceValue: number;
  gatewayId: number | string;
  billingType: 'one_time' | 'monthly';
  // catálogo/convênio da oferta, usados só no tracking de upgrade (nunca no
  // payload de checkout enviado ao backend). null no catálogo hardcoded (flag OFF).
  catalogOfferId: number | string | null;
  couponCode: string | null;
  // Opcional: só ofertas do jussub trazem; selectNewTierPlan grava no formik
  // como `paymentLinkCode` (campo raiz do POST /subscription/create).
  paymentLinkCode?: string | null;
};

// Reusado por selectNewTierPlan e pelos paywalls legados
// (ModalSubscriptionReached + variantes Jusfinder/JusfinderUnivesal) que montavam o checkout
// sempre com getSubscriptionPlans hardcoded mesmo com isNewPricingFlow, ignorando a oferta já
// resolvida (mesma classe de risco do bloqueador corrigido na 2a rodada, numa superfície diferente).
// Módulo sem dependência de tracking de propósito — os paywalls legados que só precisam desta
// função não deveriam ter que mockar app/services/tracking pra importá-la.
export const mapOfferToSubscriptionPlan = (offer: SelectableOffer, planKey: NewTierPlan['key']) => ({
  id: offer.id,
  plan_type: planKey,
  name: offer.title,
  description: offer.title,
  billingCycle: offer.billingType,
  amount: offer.priceValue,
  gateway_id: offer.gatewayId,
});
